export const GAME_TITLE = process.env.REACT_APP_GAME_NAME!
export const GAME_URL = process.env.REACT_APP_GAME_URL!

export const WIN_MESSAGES = ['WAHNSINN!', 'Großartig', 'Gute Arbeit!']
export const GAME_COPIED_MESSAGE = 'Spiel in Zwischenablage kopiert'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'Nicht genug Buchstaben'
export const WORD_NOT_FOUND_MESSAGE = 'Wort nicht gefunden'
export const HARD_MODE_ALERT_MESSAGE =
  'Der harte Modus kann nur am Anfang eingeschalten werden!'
export const HARD_MODE_DESCRIPTION =
  'Alle aufgedeckten Hinweise müssen in der nachfolgenden Vermutung benutzt werden.'
export const HIGH_CONTRAST_MODE_DESCRIPTION = 'Für verbessertes Farbsehen'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `Das Wort war ${solution}`
export const WRONG_SPOT_MESSAGE = (guess: string, position: number) =>
  `Du musst ${guess} an Position ${position} benutzen`
export const NOT_CONTAINED_MESSAGE = (letter: string) =>
  `Deine Vermutung muss ${letter} beinhalten`
export const ENTER_TEXT = 'Eingabe'
export const DELETE_TEXT = 'Löschen'
export const STATISTICS_TITLE = 'Statistiken'
export const GUESS_DISTRIBUTION_TEXT = 'Versuchsverteilung'
export const NEW_WORD_TEXT = 'Neues Wort in'
export const SHARE_TEXT = 'Teilen'
export const TOTAL_TRIES_TEXT = 'Spiele gesamt'
export const SUCCESS_RATE_TEXT = 'Spiele gewonnen'
export const CURRENT_STREAK_TEXT = 'Aktuelle Gewinnserie'
export const BEST_STREAK_TEXT = 'Längste Gewinnserie'
